import { OfflineInterface } from '@dhis2/pwa';
import PropTypes from 'prop-types';
import React, { createContext, useContext } from 'react';
const theOfflineInterface = new OfflineInterface();
const OfflineInterfaceContext = /*#__PURE__*/createContext(theOfflineInterface);
export const OfflineInterfaceProvider = _ref => {
  let {
    children
  } = _ref;
  return /*#__PURE__*/React.createElement(OfflineInterfaceContext.Provider, {
    value: theOfflineInterface
  }, children);
};
OfflineInterfaceProvider.propTypes = {
  children: PropTypes.node
};
export const useOfflineInterface = () => useContext(OfflineInterfaceContext);